import styled from "styled-components"
import { HtmlIcon, CSSIcon, JSIcon, MongoDBIcon, NodeJsIcon, ReactIcon } from "./Icons"
import { IconContext } from "react-icons"
import harmonyIcon from "../assets/3-premium.png"
import clipStudioIcon from "../assets/Clip_Studio_Paint_app_logo.png"
import creativeCloudIcon from "../assets/Adobe_Creative_Cloud_rainbow_icon.svg.png"
import mohoIcon from "../assets/Moho.png"


const SkillsnTech = () => {
    return <div>
    <StyledDivForSkills>
        <IconContext.Provider value={{className: "allIcons"}}>
            <div className="rowOfIcons hidden">
                <span className="iconAnimation hidden"><img src={harmonyIcon} width="50px"></img></span>
                <span className="iconAnimation hidden"><img src={clipStudioIcon} width="50px"></img></span>
                <span className="iconAnimation hidden"><img src={creativeCloudIcon} width="50px"></img></span>
                <span className="iconAnimation hidden"><img src={mohoIcon} width="50px"></img></span>
                <span className="iconAnimation hidden"><HtmlIcon  /></span> 
                <span className="iconAnimation hidden"><CSSIcon /> </span>
                <span className="iconAnimation hidden"><JSIcon /> </span>
                <span className="iconAnimation hidden"><MongoDBIcon /> </span>
                <span className="iconAnimation hidden"><NodeJsIcon /> </span>
                <span className="iconAnimation hidden"><ReactIcon /></span>
            </div>
        </IconContext.Provider>
    </StyledDivForSkills>
    </div>
}

const StyledDivForSkills = styled.div`
    padding: 2rem 4rem;
    border-bottom: dashed 3px var(--color-text-light);
    border-top: dashed 3px var(--color-text-light);
`

export default SkillsnTech